// -------------------------------------
// Optional Feature: Sticky Header
// -------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_header--sticky.scss';

// -------------------------------------
// Variables
// -------------------------------------
var headerInitialOffset = 0;

// Selectors
const HEADER_SELECTOR = '#shopify-section-header';
const ANNOUNCEMENT_BAR_SELECTOR = '.announcement-bar';
const PRODUCT_SECTION = '#shopify-section-product';
const BODY_NOSCROLL_SELECTOR = 'body.noscroll';

// Classes
const STICKY_CLASS = 'is-sticky';
const ANNOUNCEMENT_BAR_HIDDEN_CLASS = 'announcement-bar--hidden';

// -------------------------------------
// Initial Setup
// -------------------------------------
document.addEventListener('DOMContentLoaded', function () {
    const headerSection = document.querySelector(HEADER_SELECTOR);
    if (headerSection) {
        headerInitialOffset = headerSection.offsetTop;
    }
});

// -------------------------------------
// Scroll Event
// -------------------------------------
document.addEventListener('scroll', function () {
    const productSection = document.querySelector(PRODUCT_SECTION);
    if (productSection) return;

    const headerSection = document.querySelector(HEADER_SELECTOR);
    const announcementBar = document.querySelector(ANNOUNCEMENT_BAR_SELECTOR);
    const noScrollBody = document.querySelector(BODY_NOSCROLL_SELECTOR);
    var st = document.documentElement.scrollTop;

    if (headerSection) {
        if (st > headerInitialOffset) { // Scrolled past the header
            headerSection.classList.add(STICKY_CLASS);

            // Adjust top positioning based on menu state & announcement bar
            if (noScrollBody) {
                headerSection.style.top = '0'; // When menu is open
            } else if (!announcementBar || announcementBar.classList.contains(ANNOUNCEMENT_BAR_HIDDEN_CLASS)) {
                headerSection.style.top = '0';
            } else {
                headerSection.style.top = '0';
            }
        } else { // Scrolled above header
            headerSection.classList.remove(STICKY_CLASS);
            headerSection.style.top = noScrollBody ? '0' : '-500px';
        }
    }
});
